/**
 * Official Course Catalog for ARIVUNEST R&D
 * Features Dr. S. Sabitha Shunmuga Priya's official educational YouTube lectures
 * (Channel: Dr.Sabitha'sCorner - https://www.youtube.com/channel/UCNbUBzw7XJQbCMzsj1wSp0A)
 */

export const OFFICIAL_COURSES = [
  {
    id: 1,
    title: "English Transmission & Spoken Communication with Dr. Sabitha",
    description: "Master spoken fluency, remove psychological hesitation, and develop professional writing through Dr. Sabitha's structured linguistic method.",
    level: "All Levels",
    category: "Communication Skills",
    price: 0,
    duration: "4 Weeks",
    enrolled: "1,240+",
    rating: 4.9,
    image: "https://img.youtube.com/vi/z6WFTC1nSZw/hqdefault.jpg",
    thumbnail: "https://img.youtube.com/vi/z6WFTC1nSZw/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=z6WFTC1nSZw",
    full_json: {
      basicInfo: {
        channelName: "Dr.Sabitha'sCorner",
        host: "Dr. S. Sabitha Shunmuga Priya",
        focusAreas: ["Spoken English", "Pronunciation", "Professional Email", "Essay Writing"],
        audience: "College students, job seekers, and aspiring professionals wanting high-impact English fluency.",
      },
      learningObjectives: [
        "Eliminate fear and speech hesitation with the 'Hai! to English' foundational method.",
        "Master professional corporate email etiquette, subject lines, and formal tone.",
        "Construct structured comparative essays using block and alternating logical frameworks.",
        "Enhance sentence fluency and spontaneous conversational responses."
      ],
      modules: [
        {
          title: "Module 1: Spoken English Foundations",
          description: "Overcoming language anxiety, speech hesitation, and initiating confident English dialogue.",
          lessons: [
            {
              id: "lesson-1-1",
              title: "Hai! to English — Overcoming Hesitation & Initiating Fluency",
              description: "Dr. Sabitha introduces foundational conversational fluency, removing the affective filter and speaking with organic confidence.",
              duration: "12 min",
              videoUrl: "https://www.youtube.com/watch?v=z6WFTC1nSZw",
              thumbnail: "https://img.youtube.com/vi/z6WFTC1nSZw/hqdefault.jpg"
            }
          ]
        },
        {
          title: "Module 2: Professional & Corporate Communication",
          description: "Workplace correspondence, formal structure, and professional digital communication.",
          lessons: [
            {
              id: "lesson-1-2",
              title: "Professional Email Etiquette & Corporate Sign-offs",
              description: "Learn essential email etiquette, concise messaging, professional tone, and error-free formal correspondence.",
              duration: "6 min",
              videoUrl: "https://www.youtube.com/watch?v=pM-oiJ3VSKI",
              thumbnail: "https://img.youtube.com/vi/pM-oiJ3VSKI/hqdefault.jpg"
            }
          ]
        },
        {
          title: "Module 3: Structured Academic & Analytical Writing",
          description: "Developing logical coherence and comparative analytical essays.",
          lessons: [
            {
              id: "lesson-1-3",
              title: "Writing Compare and Contrast Essays — Block & Alternating Methods",
              description: "Master structured analytical writing, transitional linking words, and thesis development for competitive exams.",
              duration: "10 min",
              videoUrl: "https://www.youtube.com/watch?v=5rFwUE7fMKE",
              thumbnail: "https://img.youtube.com/vi/5rFwUE7fMKE/hqdefault.jpg"
            }
          ]
        }
      ]
    }
  },
  {
    id: 2,
    title: "British & American Literature, Enlightenment & Political Thought",
    description: "Explore the evolution of British literature, early American letters, and Thomas Paine's revolutionary Enlightenment philosophy.",
    level: "Intermediate",
    category: "Writing",
    price: 0,
    duration: "6 Weeks",
    enrolled: "890+",
    rating: 4.8,
    image: "https://img.youtube.com/vi/XvEYXkExW_Y/hqdefault.jpg",
    thumbnail: "https://img.youtube.com/vi/XvEYXkExW_Y/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=XvEYXkExW_Y",
    full_json: {
      basicInfo: {
        channelName: "Dr.Sabitha'sCorner",
        host: "Dr. S. Sabitha Shunmuga Priya",
        focusAreas: ["British Literature", "American Literature", "Political Philosophy", "Enlightenment"],
        audience: "Literature scholars, English majors, and competitive exam aspirants (UGC-NET, SET, GATE).",
      },
      learningObjectives: [
        "Trace the 9 major chronological divisions of British literature from Old English to the Contemporary era.",
        "Analyze Benjamin Franklin's foundational contributions to American cultural and literary identity.",
        "Examine Thomas Paine's revolutionary thesis in Rights of Man.",
        "Understand Deism, Enlightenment skepticism, and rational natural philosophy in The Age of Reason."
      ],
      modules: [
        {
          title: "Module 1: Historical Evolution of British Literature",
          description: "A chronological walkthrough of literary traditions and major movements.",
          lessons: [
            {
              id: "lesson-2-1",
              title: "British Literature Timeline — From Oral Traditions to Modernism",
              description: "Dr. Sabitha explores the nine major chronological divisions of British literary history.",
              duration: "9 min",
              videoUrl: "https://www.youtube.com/watch?v=XvEYXkExW_Y",
              thumbnail: "https://img.youtube.com/vi/XvEYXkExW_Y/hqdefault.jpg"
            }
          ]
        },
        {
          title: "Module 2: American Literary Beginnings",
          description: "The 13 colonies and early American cultural formation.",
          lessons: [
            {
              id: "lesson-2-2",
              title: "American Literature & Benjamin Franklin",
              description: "Explore early American writing, Puritan ethos, and Benjamin Franklin's Enlightenment contributions.",
              duration: "10 min",
              videoUrl: "https://www.youtube.com/watch?v=HIuQBLqzxM0",
              thumbnail: "https://img.youtube.com/vi/HIuQBLqzxM0/hqdefault.jpg"
            }
          ]
        },
        {
          title: "Module 3: Revolutionary Political Philosophy",
          description: "Human rights, republican ideals, and critiques of hereditary tyranny.",
          lessons: [
            {
              id: "lesson-2-3",
              title: "Analysis of 'Rights of Man' by Thomas Paine",
              description: "A deep dive into Paine's defense of the French Revolution and advocacy of fundamental human equality.",
              duration: "26 min",
              videoUrl: "https://www.youtube.com/watch?v=ivddyOu3J0o",
              thumbnail: "https://img.youtube.com/vi/ivddyOu3J0o/hqdefault.jpg"
            },
            {
              id: "lesson-2-4",
              title: "The Age of Reason & Enlightenment Deism",
              description: "Critique of institutional dogma, promotion of rational inquiry, and nature as revelation.",
              duration: "8 min",
              videoUrl: "https://www.youtube.com/watch?v=NrVSZ8kpvsg",
              thumbnail: "https://img.youtube.com/vi/NrVSZ8kpvsg/hqdefault.jpg"
            }
          ]
        }
      ]
    }
  },
  {
    id: 3,
    title: "AI-Powered Grammar Kata & Active Pronunciation Labs",
    description: "Rapid-fire daily grammar drills, pause frequency reduction, and real-time pronunciation feedback powered by Google Gemini.",
    level: "Beginner",
    category: "Grammar",
    price: 0,
    duration: "30 Days",
    enrolled: "2,410+",
    rating: 4.9,
    image: "https://img.youtube.com/vi/z6WFTC1nSZw/hqdefault.jpg",
    thumbnail: "https://img.youtube.com/vi/z6WFTC1nSZw/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=z6WFTC1nSZw",
    full_json: {
      basicInfo: {
        host: "ARIVUNEST R&D AI Lab",
        focusAreas: ["Grammar Kata", "Sentence Logic", "Pronunciation Analysis"],
        audience: "ESL learners desiring sharp grammatical intuition and clear accent modulation."
      },
      learningObjectives: [
        "Internalize tense consistency and subject-verb agreement through repetitive kata exercises.",
        "Minimize fillers and hesitation gaps with pacing and cadence feedback.",
        "Build spontaneous English reflex without mentally translating from mother tongue."
      ],
      modules: [
        {
          title: "Daily Drill Tracks",
          description: "Iterative mastery modules for daily practice.",
          lessons: [
            {
              id: "lesson-3-1",
              title: "Pronunciation & Cadence Calibration",
              description: "Interactive audio recording with real-time feedback.",
              duration: "15 min",
              videoUrl: "https://www.youtube.com/watch?v=z6WFTC1nSZw",
              thumbnail: "https://img.youtube.com/vi/z6WFTC1nSZw/hqdefault.jpg"
            }
          ]
        }
      ]
    }
  },
  {
    id: 4,
    title: "Corporate Workplace Communication & Interview Fluency",
    description: "Comprehensive training for engineering and arts graduates on corporate presentations, technical interviews, and cross-cultural discourse.",
    level: "Advanced",
    category: "Business Communication",
    price: 0,
    duration: "3 Weeks",
    enrolled: "1,580+",
    rating: 4.9,
    image: "https://img.youtube.com/vi/pM-oiJ3VSKI/hqdefault.jpg",
    thumbnail: "https://img.youtube.com/vi/pM-oiJ3VSKI/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=pM-oiJ3VSKI",
    full_json: {
      basicInfo: {
        host: "Arivu Nest R&D Industry Wing",
        focusAreas: ["Interview Fluency", "Corporate Vocabulary", "Technical Presentations"],
        audience: "Final year students, job seekers, and working professionals."
      },
      learningObjectives: [
        "Master STAR format for behavioral interview questions.",
        "Deliver clear, structured technical presentations to multidisciplinary stakeholders.",
        "Write executive summaries, meeting minutes, and professional proposals."
      ],
      modules: [
        {
          title: "Corporate Preparation",
          description: "Essential soft skills and technical articulation.",
          lessons: [
            {
              id: "lesson-4-1",
              title: "Corporate Email & Technical Discourse",
              description: "Mastering professional tone and corporate etiquette.",
              duration: "20 min",
              videoUrl: "https://www.youtube.com/watch?v=pM-oiJ3VSKI",
              thumbnail: "https://img.youtube.com/vi/pM-oiJ3VSKI/hqdefault.jpg"
            }
          ]
        }
      ]
    }
  }
];
